import * as React from 'react';
import styles from '../dialog/overlay.module.css';


export default function CustomizedDialog({ searchValue, searchPlayers  }) {
  const isDisabled = !(searchValue?.length > 0);

  return (
    <div >
      <input
        type='button'
        disabled={isDisabled}
        className={isDisabled ? styles.disabled : styles.searchButton}
        value='Search'
        onClick={() => {
          if (!isDisabled) searchPlayers('asc', 'full_name');
        }}
      />
    </div>
  );
}
